export const INavigateToTipUseCaseType = Symbol('INavigateToTipUseCase');
